(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('releve-compteur', {
            parent: 'entity',
            url: '/releve-compteur?page&sort&search&etat&collecteur&startDate&endDate',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.releveCompteur.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/releve-compteur/releve-compteurs.html',
                    controller: 'ReleveCompteurController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'dateReleve,desc',//'etat,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('releveCompteur');
                    $translatePartialLoader.addPart('individualMeter');
                    $translatePartialLoader.addPart('etatReleveCompteur');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('releve-compteur-detail', {
            parent: 'entity',
            url: '/releve-compteur/{id}',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.releveCompteur.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/releve-compteur/releve-compteur-detail.html',
                    controller: 'ReleveCompteurDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('releveCompteur');
                    $translatePartialLoader.addPart('etatReleveCompteur');
                    $translatePartialLoader.addPart('individualMeter');
                    return $translate.refresh();
                }]
            /*,
                entity: ['$stateParams', 'ReleveCompteur', function($stateParams, ReleveCompteur) {
                    return ReleveCompteur.get({id : $stateParams.id});
                }]*/
            }
        })
        .state('releve-compteur-map', {
            parent: 'entity',
            url: '/releve-compteur/{id}/map',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.releveCompteur.map.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/releve-compteur/releve-compteur-map.html',
                    controller: 'ReleveCompteurMapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('releveCompteur');
                    $translatePartialLoader.addPart('etatReleveCompteur');
                    $translatePartialLoader.addPart('individualMeter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('releve-compteur-control', {
            parent: 'entity',
            url: '/releve-compteur/{id}/control',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.releveCompteur.control.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/releve-compteur/releve-compteur-control.html',
                    controller: 'ReleveCompteurControlController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('releveCompteur');
                    $translatePartialLoader.addPart('etatReleveCompteur');
                    $translatePartialLoader.addPart('individualMeter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('releve-compteur.new', {
            parent: 'releve-compteur',
            url: '/new',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/releve-compteur/releve-compteur-dialog.html',
                    controller: 'ReleveCompteurDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            	dateReleve: null,
                                etat: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('releve-compteur', null, { reload: true });
                }, function() {
                    $state.go('releve-compteur');
                });
            }]
        })
  /*      .state('releve-compteur.edit', {
            parent: 'releve-compteur',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_DATA_OPERATOR','ROLE_READ_ONLY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/releve-compteur/releve-compteur-dialog.html',
                    controller: 'ReleveCompteurDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReleveCompteur', function(ReleveCompteur) {
                            return ReleveCompteur.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('releve-compteur', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })*/
        .state('releve-compteur.delete', {
            parent: 'releve-compteur',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_DATA_OPERATOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/releve-compteur/releve-compteur-delete-dialog.html',
                    controller: 'ReleveCompteurDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ReleveCompteur', function(ReleveCompteur) {
                           // return {id : $stateParams.id};
                            return ReleveCompteur.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('releve-compteur', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
